import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { FirestoreService } from 'src/app/services/service.index';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from 'src/app/components/dialog/dialog.component';
declare var google;

@Component({
  selector: 'app-orderdetails',
  templateUrl: './orderdetails.component.html',
  styleUrls: ['./orderdetails.component.css']
})
export class OrderdetailsComponent implements OnInit {

  user:any;
  orders:any;
  mapOptions:any;

  @ViewChild('mapContainer', { static: false }) gmap: ElementRef;
  map:any;

  productLat:any;
  productLng:any;

  marker:any;

  constructor(public afs: FirestoreService,  private activatedRoute: ActivatedRoute,  private router: Router, public dialog: MatDialog) { }



  ngAfterViewInit() {




       Swal.fire({
         title: 'Loading Order Detail!',
         //html: 'data uploading', // add html attribute if you want or remove
         timer: 5000,
         allowOutsideClick: false,
         onBeforeOpen: () => {
           Swal.showLoading();
         },
       });



    this.user = this.afs.usersShow;


    this.activatedRoute.params.subscribe(params => {




      //console.log(params.id);

      this.afs.getOrder(this.user.companyId, params.id).subscribe( resp  => {


          this.orders = resp;

          console.log(this.orders);

          this.mapInitializer(this.orders);



      });

    });

   }

  ngOnInit(): void {






  }


  mapInitializer(coords: any) {

    navigator.geolocation.getCurrentPosition((position) => {
      // place your product lat or longtitude here
      this.productLat = position.coords.latitude;// change it to your preferences
      this.productLng = position.coords.longitude; // <-- static



    const coordinates = new google.maps.LatLng(this.productLat, this.productLng); // init our coordinate for marker :)

    // check here to get to know about map options docs
    this.mapOptions = google.maps.MapOptions = {
    // here to place centering our location based on coordinates
    center: coordinates,
    zoom: 18,
    fullscreenControl: false,
    mapTypeControl: false,
    streetViewControl: false
    };
    //set our lovely google maps here and marker here
    this.map = new google.maps.Map(this.gmap.nativeElement, this.mapOptions);

    let pos = new google.maps.LatLng(coords.coords.lat, coords.coords.lng);

    this.marker = new google.maps.Marker({
      position: pos,
      map: this.map
    });

    this.map.setCenter(pos);

     });

    }




  imagenModal(img){

   /* Swal.fire({
      imageUrl: img,
      imageWidth: 500,
      imageHeight: 400,
      padding: 0,
    })*/

    const dialogRef = this.dialog.open(DialogComponent, {
      data: {
          img: img
      }
    });

  }


  getColorStatus(status){

    if(status == 0){
        return '#e74c3c'
    }else if(status ==1){
       return '#2980b9'
    }else if(status == 2){
       return '#2ecc71'
    }else if(status == 3){
        return '#e74c3c'
     }

}

statusOrder(status){

  if(status == 0)
  {
    return "Pending";
  }
  else if(status == 1)
  {
    return "Assigned";
  }
  else if(status == 2)
  {
    return "Delivered";
  }
  else if(status == 3)
  {
    return "Reject";
  }
}

}
